import { BidQuestionType } from 'src/models/bids/BidFull/types';
import { QuestionStatus, TaskFulfillment, ResponseType } from 'src/models/bids/BidTask/types';
import { safeCallSegment } from '../helpers';
import { PickerMode } from 'src/shared/Bid/TaskFulfillmentPicker';

// BT: Create task
export function trackBTCreateTask(groupId: string, bidId?: string): void {
  safeCallSegment(() => {
    analytics.track('BT create task', {
      bidId,
      groupId
    });
  });
}

// BT: Delete task
export function trackBTDeleteTask(
  mode: PickerMode,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType
): void {
  safeCallSegment(() => {
    analytics.track('BT delete task', {
      bidId,
      groupId,
      taskType,
      mode
    });
  });
}

// BT: Task stage
export function trackBTTaskStage(
  mode: PickerMode,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType,
  status?: TaskFulfillment
): void {
  safeCallSegment(() => {
    analytics.track('BT task stage', {
      bidId,
      groupId,
      mode,
      taskType,
      status
    });
  });
}

// BT: Task status
export function trackBTTaskStatus(
  mode: PickerMode,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType,
  status?: QuestionStatus
): void {
  safeCallSegment(() => {
    analytics.track('BT task status', {
      bidId,
      groupId,
      mode,
      taskType,
      status
    });
  });
}

// BT: Assign task
export function trackBTAssignTask(
  mode: PickerMode,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType
): void {
  safeCallSegment(() => {
    analytics.track('BT assign task', {
      bidId,
      groupId,
      mode,
      taskType
    });
  });
}

// BT task answer type
export function trackBTTaskAnswerType(
  mode: PickerMode,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType,
  answerType?: ResponseType
): void {
  safeCallSegment(() => {
    analytics.track('BT task answer type', {
      bidId,
      groupId,
      mode,
      taskType,
      answerType
    });
  });
}

// BT upload file
export function trackBTUploadFile(taskId: string, groupId?: string, bidId?: string, taskType?: BidQuestionType): void {
  safeCallSegment(() => {
    analytics.track('BT upload file', {
      bidId,
      groupId,
      taskId,
      taskType
    });
  });
}

// BT saves free text
export function trackBTSavesFreeText(
  taskId: string,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType
): void {
  safeCallSegment(() => {
    analytics.track('BT saves free text', {
      bidId,
      groupId,
      taskId,
      taskType
    });
  });
}

// BT: open detailed task view
export function trackBTOpenDetailedTaskView(args: {
  taskId: string;
  eventSource: string;
  groupId?: string;
  bidId?: string;
  taskType?: BidQuestionType;
}): void {
  const { taskId, eventSource, groupId, bidId, taskType } = args;
  safeCallSegment(() => {
    analytics.track('BT open detailed task view', {
      bidId,
      groupId,
      taskId,
      taskType,
      eventSource
    });
  });
}

// BT: generate answer
export function trackBTGenerateAnswer(
  taskId: string,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType
): void {
  safeCallSegment(() => {
    analytics.track('BT generate answer', {
      bidId,
      groupId,
      taskId,
      taskType
    });
  });
}

// BT: use generated answer
export function trackBTUseGeneratedAnswer(
  taskId: string,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType
): void {
  safeCallSegment(() => {
    analytics.track('BT use generated answer', {
      bidId,
      groupId,
      taskId,
      taskType
    });
  });
}

// BT: show more on generated answer
export function trackBTShowMoreOnGeneratedAnswer(
  taskId: string,
  groupId?: string,
  bidId?: string,
  taskType?: BidQuestionType
): void {
  safeCallSegment(() => {
    analytics.track('BT show more on generated answer', {
      bidId,
      groupId,
      taskId,
      taskType
    });
  });
}

// BT: show more
export function trackBTShowMore(taskId: string, groupId?: string, bidId?: string, taskType?: BidQuestionType): void {
  safeCallSegment(() => {
    analytics.track('BT show more', {
      bidId,
      groupId,
      taskId,
      taskType
    });
  });
}
